import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <div>
        <p className={styles.text}>
          Apple Pencilの利用は、現在サポート対象外です。
          <br />
          入力やキーボード動作が不安定になる場合があります。
          <br />
          不安定な場合は、以下をお試しください。
        </p>
        <ul className={styles.list}>
          <li className={styles.item}>アプリまたは端末の再起動</li>
          <li className={styles.item}>Safariブラウザからの利用</li>
        </ul>
      </div>
    </div>
  </div>
);

export const IPAD_APPLE_PENCIL_UNSTABLE_FAQ: FaqCategoryItem = {
  id: "ipad-apple-pencil-unstable-faq",
  question: "iPad Apple Pencilの動作が不安定",
  Answer,
};
